import * as Styled from './BulletedListItem.styled';
import type { BulletedListItemProps } from './BulletedListItem.typed';
import React from 'react';

export const BulletedListItem = (props: BulletedListItemProps) => {
  const { children } = props;
  return <Styled.ListItem>{children}</Styled.ListItem>;
};
